import { useRachelPresentation } from '../../hooks/useRachelPresentation';
import { RachelUIMessage } from '../../rachel.types';
import RachelAssistantMessage from './components/RachelAssistantMessage/RachelAssistantMessage';
import RachelUserMessage from './components/RachelUserMessage/RachelUserMessage';

interface RachelMessageItemProps {
  message: RachelUIMessage;
  isLive: boolean;
  isLastMessage: boolean;
}

const RachelMessageItem = ({ message, isLive, isLastMessage }: RachelMessageItemProps) => {
  const presentation = useRachelPresentation();

  if (message.role === 'user') {
    return <RachelUserMessage message={message} isOnPage={presentation.mode === 'page'} />;
  }

  return <RachelAssistantMessage message={message} isLive={isLive} isLastMessage={isLastMessage} />;
};

export default RachelMessageItem;
